import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const CancelMembership = loadable(() => pMinDelay(import('./CancelMembership'), 300), {
  fallback: <Loading />
});

const AsyncCancelMembership = props => {
  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation bg-solid-gray`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <CancelMembership { ...props }/>
    </ApplicationLayout>
  );
};

AsyncCancelMembership.propTypes = {
  userAgent: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default AsyncCancelMembership;
